export const isEmptyObj = (obj: Record<string, unknown>) => {
  return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype
}
